import Cookies from 'js-cookie'

const TokenKey = 'hxg_user_access_token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  // 创建一个cookie，自定义过期时间（一般过期时间的设置以天为单位，这里可以使用时间戳自定义过期时间，例如过期时间为：半小时）
  // let time = new Date(new Date().getTime() + 30 * 60 * 1000);
  let time = new Date(new Date().getTime() + 60 * 60 * 1000 * 24 *3650);
  //或
  // let time = new Date(new Date() * 1 + 30 * 60 * 1000);
  return Cookies.set(TokenKey, token, { expires: time });
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setCookie(name, value) {
  return Cookies.set(name, value)
}

export function getCookie(name) {
  return Cookies.get(name)
}


// WEBPACK FOOTER //
// ./src/utils/auth.js